export default {
    dependencies: ['$element'],
    callable(ele) {
        ele.addEventListener('input', () => {
            const url = new URL(document.baseURI);
            url.searchParams.set(ele.name, ele.value);
            window.history.replaceState(window.history.state, '', url.href);
        });
    },
};



// WEBPACK FOOTER //
// ./controllers/searchUrlUpdate.js